import { useParams, useSearch } from "@tanstack/react-router";
import { SpectatorView, PlayerView } from "./Views";
import { useCallback } from "react";

function Ludo() {
	const { matchID, token } = useParams({
		from: "/ludo/$token/$matchID",
	});
	const { clientId, gameMode } = useSearch({
		from: "/ludo/$token/$matchID",
	});
	const GameView = useCallback(() => {
		return gameMode === "spectator" ? (
			<SpectatorView clientId={clientId} matchID={matchID} token={token} />
		) : (
			<PlayerView clientId={clientId} matchID={matchID} token={token} />
		);
	}, [clientId, matchID, token, gameMode]);
	return <GameView />;
}

export default Ludo;
